export function handleMopinion(id) {
  // Select all scripts with the given src attribute
  var existingScripts = document.querySelectorAll('script[src="//deploy.mopinion.com/js/pastease.js"]')

  // Remove all selected scripts
  existingScripts.forEach((script) => {
    script.remove()
  })

  var js = document.createElement("script")
  js.setAttribute("type", "text/javascript")
  js.setAttribute("src", "//deploy.mopinion.com/js/pastease.js")
  js.async = true

  js.addEventListener("load", function () {
    var t = setInterval(function () {
      if (window.Pastease) {
        try {
          window.Pastease.load(id)
          clearInterval(t)
        } catch (e) {
          console.error("Error loading Mopinion", e)
        }
      }
    }, 50)
  })

  document.getElementsByTagName("head")[0].appendChild(js)
}
